/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ms_TargetInputs */

const en_ms_target = /** @type {(inputs: Ms_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Target`)
};

const de_ms_target = /** @type {(inputs: Ms_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ziel`)
};

/**
* | output |
* | --- |
* | "Target" |
*
* @param {Ms_TargetInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ms_target = /** @type {((inputs?: Ms_TargetInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ms_TargetInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ms_target(inputs)
	return en_ms_target(inputs)
});